import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DashboardChecklistCardContent } from "./dashboard/checklist.js";
import { useStores } from "../../store/stores.js";
import { __ } from "../../utils/i18n.js";
import { ProHeadlineButton } from "../proHeadlineButton.js";
const ConfigHeader = observer(()=>{
    const [isChecklistModalOpen, setChecklistModalOpen] = useState(false);
    const { optionStore, checklistStore } = useStores();
    const { pathname } = useLocation();
    const { others: { customizeBannerUrl }, publicUrl } = optionStore;
    const { completed, checkable, done } = checklistStore;
    useEffect(()=>{
        checklistStore.fetchChecklist();
    }, []);
    const handleCustomizeBannerButtonClick = useCallback((e)=>{
        window.location.href = `${customizeBannerUrl}&return=${encodeURIComponent(window.location.href)}`;
        e.preventDefault();
    }, []);
    const handleChecklistModalOpen = useCallback(()=>{
        setChecklistModalOpen(true);
        checklistStore.fetchChecklist();
    }, [
        setChecklistModalOpen
    ]);
    const handleChecklistModalClose = useCallback(()=>{
        setChecklistModalOpen(false);
    }, [
        setChecklistModalOpen
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "wp-heading-inline",
                children: __("Real Cookie Banner")
            }),
            /*#__PURE__*/ _jsx("img", {
                className: "rcb-nav-logo",
                src: `${publicUrl}images/logos/real-cookie-banner.svg`
            }),
            /*#__PURE__*/ _jsx("a", {
                className: "page-title-action",
                href: "#",
                onClick: handleCustomizeBannerButtonClick,
                children: __("Customize banner")
            }),
            /*#__PURE__*/ _jsx(ProHeadlineButton, {}),
            !done && pathname !== "/" && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("a", {
                        className: "page-title-action",
                        style: {
                            color: "#52c41a",
                            background: "#f6ffed",
                            borderColor: "#85af65"
                        },
                        onClick: handleChecklistModalOpen,
                        children: [
                            /*#__PURE__*/ _jsx(CheckCircleOutlined, {}),
                            "\xa0",
                            __("%d / %d steps completed", completed.length > checkable.length ? checkable.length : completed.length, checkable.length)
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Modal, {
                        open: isChecklistModalOpen,
                        title: __("Set up the cookie banner"),
                        onCancel: handleChecklistModalClose,
                        okButtonProps: {
                            style: {
                                display: "none"
                            }
                        },
                        cancelText: __("Close"),
                        width: 800,
                        children: /*#__PURE__*/ _jsx(DashboardChecklistCardContent, {
                            showHidden: true,
                            onLinkClick: handleChecklistModalClose
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "wp-header-end"
            })
        ]
    });
});
export { ConfigHeader };
